import type { Components, Theme } from '@mui/material';

export const buttonConfig: Components<Omit<Theme, 'components'>> = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
      variant: 'primary',
      size: 'md',
    },
  },
  MuiIconButton: {
    defaultProps: {
      disableRipple: true,
      size: 'md',
    },
  },
};
